<template>
  <div class="main" v-drag>
    <!-- <p>
      A1型题：每一道试题下面有A、B、C、D、E五个备选答案。请从中选择一个最佳答案。
      A2型题：每一道考题是以一个小案例出现的，其下面都有A、B、C、D、E五个备选答案。请从中选择一个最佳答案
      A3/A4型题：以下提供若干个案例，每个案例下设若干道考题。请根据答案所提供的信息，在每一道考题下面的A、B、C、D、E五个备选答案中选择一个最佳答案。
      B1型题：以下提供若干组考题，每组考题共用在考题前列出的A、B、C、D、E五个备选答案。请从中选择一个与问题关系最密切的答案。某个备选答案可能被选择一次、多次或不被选择。
      A3型题：以下提供若干个案例，每个案例下设若干道考题。请根据答案所提供的信息，在每一道考题下面的A、B、C、D、E五个备选答案中选择一个最佳答案。
      X型题：每道试题由1个题干和5个备选答案组成，每题至少有2个正确答案，多选、少选、漏选均不得分。
    </p> -->
    <el-collapse-transition>
      <div v-show="show3">
        <div class="transition-box">
          <p>
            <span>A1型题：</span>
            每一道试题下面有A、B、C、D、E五个备选答案。请从中选择一个最佳答案。
          </p>
          <p>
            <span>A2型题：</span>
            每一道考题是以一个小案例出现的，其下面都有A、B、C、D、E五个备选答案。请从中选择一个最佳答案
          </p>
          <p>
            <span>A3/A4型题：</span>
            以下提供若干个案例，每个案例下设若干道考题。请根据答案所提供的信息，在每一道考题下面的A、B、C、D、E五个备选答案中选择一个最佳答案。
          </p>
          <p>
            <span>B1型题：</span>
            以下提供若干组考题，每组考题共用在考题前列出的A、B、C、D、E五个备选答案。请从中选择一个与问题关系最密切的答案。某个备选答案可能被选择一次、多次或不被选择。
          </p>
          <p>
            <span>A3型题：</span>
            以下提供若干个案例，每个案例下设若干道考题。请根据答案所提供的信息，在每一道考题下面的A、B、C、D、E五个备选答案中选择一个最佳答案。
          </p>
          <p>
            <span> X型题：</span>
            每道试题由1个题干和5个备选答案组成，每题至少有2个正确答案，多选、少选、漏选均不得分。
          </p>
          <!-- <p>
            A1型题：每一道试题下面有A、B、C、D、E五个备选答案。请从中选择一个最佳答案。
            A2型题：每一道考题是以一个小案例出现的，其下面都有A、B、C、D、E五个备选答案。请从中选择一个最佳答案
            A3/A4型题：以下提供若干个案例，每个案例下设若干道考题。请根据答案所提供的信息，在每一道考题下面的A、B、C、D、E五个备选答案中选择一个最佳答案。
            B1型题：以下提供若干组考题，每组考题共用在考题前列出的A、B、C、D、E五个备选答案。请从中选择一个与问题关系最密切的答案。某个备选答案可能被选择一次、多次或不被选择。
            A3型题：以下提供若干个案例，每个案例下设若干道考题。请根据答案所提供的信息，在每一道考题下面的A、B、C、D、E五个备选答案中选择一个最佳答案。
            X型题：每道试题由1个题干和5个备选答案组成，每题至少有2个正确答案，多选、少选、漏选均不得分。
          </p> -->
          <el-button @click="show3 = false">关闭</el-button>
        </div>
        <!-- <div class="transition-box">el-collapse-transition</div> -->
      </div>
    </el-collapse-transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show3: false,
    };
  },
  // 拖拽事件
  directives: {
    drag(el, bindings) {
      el.onmousedown = function (e) {
        var disx = e.pageX - el.offsetLeft;
        var disy = e.pageY - el.offsetTop;
        document.onmousemove = function (e) {
          el.style.left = e.pageX - disx + "px";
          el.style.top = e.pageY - disy + "px";
        };
        document.onmouseup = function () {
          document.onmousemove = document.onmouseup = null;
        };
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  position: fixed;
  top: 50%;
   left: 50%;
   transform: translate(-50%, -50%);
   z-index: 99999999;
}
.transition-box {
  margin-bottom: 10px;
  width: 700px;
  min-height: 100px;
  border-radius: 4px;
    background-color: #FFF;
  text-align: center;
  //   color: #fff;
  border: 1px solid #eee;
  padding: 20px;
  box-sizing: border-box;
  margin-right: 20px;
}
.transition-box >p{
    text-align: left;
    margin: 16px 0px;
    font-size: 16px;
    >span{
        font-size: 20px;
        font-weight: bolder;
    }
    
}
.el-button{
    width: 120px;
        background: #1890ff;
        color: #fff;
    }
</style>